import React from 'react';
import type { SurveyStepProps } from '../types';
import { Box, SpacingStack } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { NavigationButton } from '../../components/NavigationButton';
import { useContactFormData } from './useContactFormData';
import { Form } from '@apps/contactCollector/guest/routes/Form/Form';
import { useNavButtonStyles } from '../../hooks/useNavButtonStyles';
import { STEP_MINIMUM_HEIGHT } from '../consts';

export const EventFormContactStep = (props: SurveyStepProps) => {
  const { hasPrev, onBack, onNext, formState, settings, colors, setFormState } = props;

  const handleSubmit = (values: SurveyStepProps['formState']['contactValues']) => {
    setFormState(prev => ({ ...prev, contactValues: values }));
    onNext();
  };

  const { formik, e164PhoneNumber, setE164PhoneNumber } = useContactFormData(settings, handleSubmit, formState.contactValues);
  const { solidButtonStyles } = useNavButtonStyles(colors);

  const { tq } = useTranslation('eventFormDisplay');

  return (
    <Box>
      <SpacingStack gap="1rem">
        <Form
          formik={formik}
          isIframeVersion
          isCollectHouseholdEnabled={false}
          e164PhoneNumber={e164PhoneNumber}
          setE164PhoneNumber={setE164PhoneNumber}
          phoneNumberRule={settings.phoneFields}
          mailingAddressRule={settings.addressFields}
          isRegistration
          overrides={{
            submitButtonProps: {
              shape: 'rounded',
              ...solidButtonStyles,
            },
            submitButtonLabel: tq`Next`,
            extraCTAs: hasPrev ? (
              <NavigationButton
                onClick={onBack}
                direction="prev"
              />
            ) : null,
            // !important required because Form inner sets width via a media query.
            wrapperProps: {
              width: '100% !important',
              marginTop: '0px !important',
              __css: {
                '& label': {
                  ...(colors?.pageFontColor ? { color: colors.pageFontColor } : {}),
                  fontFamily: 'Inter UI',
                },
              },
            },
            disableAddressValidation: true,
            formMinHeight: STEP_MINIMUM_HEIGHT,
          }}
        />
      </SpacingStack>
    </Box>
  );
};
